import { TFunction } from 'i18next'
import { OnboardingStep } from 'types/onboardingTypes'

export function existingEmailLogin(t: TFunction): OnboardingStep {
  return {
    id: 'existing_email_login',
    type: 'custom',
    wordings: {
      title: ''
    }
  }
}
